import { App } from 'vue';
import './validation.plugin';

import InputCheckbox from './InputCheckbox.vue';
import InputErrors from './InputErrors.vue';
import InputClear from './InputClear.vue';
import InputRadio from './InputRadio.vue';
import InputSelect from './InputSelect.vue';
import InputText from './InputText.vue';
import InputTextarea from './InputTextarea.vue';
import InputPhone from './InputPhone.vue';
import InputErrorMessage from './InputErrorMessage.vue';
import ConfirmationButton from './ConfirmationButton.vue';
import ToggleButton from '@/shared/form/ToggleButton.vue';
import AirbnbStyleDatepicker from '@/shared/form/airbnb-style-datepicker/AirbnbStyleDatepicker.vue';

export default function formComponentRegistration(app: App<Element>) {
    app.component('InputCheckbox', InputCheckbox);
    app.component('InputErrors', InputErrors);
    app.component('InputClear', InputClear);
    app.component('InputRadio', InputRadio);
    app.component('InputSelect', InputSelect);
    app.component('InputText', InputText);
    app.component('InputTextarea', InputTextarea);
    app.component('InputPhone', InputPhone);
    app.component('InputErrorMessage', InputErrorMessage);
    app.component('ConfirmationButton', ConfirmationButton);
    app.component('ToggleButton', ToggleButton);
    app.component('AirbnbStyleDatepicker', AirbnbStyleDatepicker);
}
